export default "__VITE_ASSET__BUl1bWl3__"